import React, { useEffect, useState } from "react";
import { useDispatch} from "react-redux";
import { useSearchParams } from "react-router-dom";
import { closeMenu } from "../utils/appSlice";
import CommentsContainer from "./CommentsContainer";
import LiveChat from "./LiveChat";
import VideoContainer from "./VideoContainer";
import SuggestionsContainer from "./SuggestionsContainer";
import ChannelCard from "./ChannelCard";
import OriginalComments from "./OriginalComments";

const WatchPage = () => {
  const [searchParams] = useSearchParams();
  const [videoId,setVideoId] = useState(searchParams.get("v"));
  
  // const isMenuOpen = useSelector((store) => store.app.isMenuOpen);

  useEffect(()=>{
    setVideoId(searchParams.get("v"));
  },[videoId,searchParams]);

    useEffect(() => {
        // Scroll to the top of the page when the component mounts or videoId changes
        window.scrollTo(0, 0);
    }, [searchParams]); // Dependency array ensures this runs whenever videoId changes


  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(closeMenu());
  }, []);

  return (
    <div className="flex md:ml-[10%] md:my-[5%] my-[10%] flex-col w-screen md:h-[100%] h-[100%]">
      <div className="px-5 flex h-[70%]">
        <div className="md:w-[70%] w-screen md:h-[100%] h-[70%] ">
          <iframe
            className="w-full md:h-[70vh] h-[30vh]"
            // height="600"
            // width="850"
            src={"https://www.youtube.com/embed/" + videoId}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        <ChannelCard videoId={videoId}/>
        </div>
        <div className="md:block md:w-[30%] hidden ">
          <p className="font-bold text-xl ml-3 mb-2">Live Chat</p>
          <LiveChat />
        </div>
      </div>
      <div className="flex h-[30%]">
      <div className="h-[100%] md:ml-[-10%] md:w-[70%]">
      {/* <CommentsContainer /> */}
      <OriginalComments videoId={videoId}/>
      </div>
      <div className="md:pt-[2%] md:ml-[10%] md:w-[30%] md:block hidden">
        <p className="font-bold text-xl">Watch Next</p>
      <SuggestionsContainer />
      </div>
      </div>
    </div>
  );
};

export default WatchPage;
